import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const HomeService = {
    userHome: () => axios.get(API_URL + "/home/getUserHome").then(({ data }) => data.data).catch((err) => { throw err }),

    status: () => axios.get(API_URL + "/home/status").then(({ data }) => data).catch((err) => { throw err }),

    update: (formData) => axios.post(API_URL + "/home/setCards", formData).catch((err) => { throw err }),

    accessVms: (url) => axios.get(`${API_URL}/${url.replace(/^\//, "")}`).then(({ data }) => data).catch((err) => { throw err }),

    loginHash: () => axios.post(API_KEEPER + "/get-hash?url=%2F").then(({ data }) => data).catch((err) => { throw err }),

    poll: (uuid) => axios.post(API_KEEPER + "/long/poll/add/" + uuid).then((response) => response).catch((err) => { throw err }),
};

export default HomeService;
